import ownerDocument from './owner-document';
export var getWindow = function (element) { return ownerDocument(element).defaultView; };



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-popup-common/dist/es/window.js
// module id = 150
// module chunks = 93